import moment from "moment";

export const formatTimestamp = (timestamp: string | number): string => {
  const messageDate = moment(timestamp); // moment can accept a number (milliseconds) directly
  const now = moment();

  if (!messageDate.isValid()) {
    return "";
  }

  if (now.isSame(messageDate, "day")) {
    return messageDate.format("hh:mm A");
  } else if (now.diff(messageDate, "days") === 1) {
    return "Yesterday";
  } else if (now.year() === messageDate.year()) {
    return messageDate.format("DD/MM/YY");
  } else {
    return messageDate.format("DD/MM/YY");
  }
};
